module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboarding-detail"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/onboarding"
    }
  }, [_vm._v(_vm._s(_vm.$t('Onboarding List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Onboarding Detail')))])])]), (_vm.notify) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert",
    class: _vm.notify.danger ? 'alert-danger' : 'alert-success'
  }, [_c('span', [_vm._v(_vm._s(_vm.notify.message))])])])]) : _vm._e(), (_vm.forbidden) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.message.forbidden')))])])])]) : _vm._e(), (_vm.user && _vm.searchCallbackFlag) ? _c('div', [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name) + " " + _vm._s(_vm.user.user_firstname))]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.shop_name')))]), _c('td', [_vm._v(_vm._s(_vm.user.shop_name))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('onboarding.label.join_day')))]), _c('td', [_vm._v(_vm._s(_vm.user.user_joinday_format))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('onboarding.label.employment_pattern')))]), _c('td', [_vm._v(_vm._s(_vm.user.employment_pattern_i18n || '-'))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('onboarding.label.email')))]), _c('td', [_vm._v(_vm._s(_vm.user.email_address))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('onboarding.label.status')))]), _c('td', [_vm._v(_vm._s(_vm.user.onboarding_status_i18n))])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('onboarding.label.invitation')))]), _c('td', [(_vm.user.invitation_valid) ? _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.label.invitation_valid')))]) : _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.invitation_expired')))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": _vm.resendInvitation
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.button.resend')))])])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('onboarding.label.my_number')))]), _c('td', [(_vm.user.my_number_submitted) ? _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.label.submitted')))]) : _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.not_submitted')))]), (_vm.isHrManager && _vm.user.my_number_submitted) ? _c('div', {
    staticClass: "my-number-box margin-top"
  }, [(!_vm.myNumber) ? _c('a', {
    staticClass: "btn btn-xs btn-danger",
    on: {
      "click": _vm.showMyNumber
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.button.show_my_number')))]) : _vm._e(), (_vm.myNumber) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.myNumber.my_number))]), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.my_number_logged')))])]) : _vm._e()]) : _vm._e()])])])])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.contract')))]), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.contract) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('onboarding.label.employment_pattern')) + "：" + _vm._s(_vm.contract.employment_pattern_i18n))]), _c('p', [_vm._v(_vm._s(_vm.$t('onboarding.label.contract_period_to')) + "：" + _vm._s(_vm.contract.contract_period_to_format))]), (_vm.contract.is_consented) ? _c('p', [_vm._v(_vm._s(_vm.$t('onboarding.label.consented_at')) + "：" + _vm._s(_vm.contract.consented_at_format))]) : _c('p', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.not_consented')))])]) : _c('div', [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.no_contract')))])]), _c('div', {
    staticClass: "form-inline margin-top"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentPattern),
      expression: "employmentPattern"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.employmentPattern = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "full_time"
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.employment_pattern.full_time')))]), _c('option', {
    attrs: {
      "value": "part_free"
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.employment_pattern.part_free')))]), _c('option', {
    attrs: {
      "value": "part_80"
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.employment_pattern.part_80')))]), _c('option', {
    attrs: {
      "value": "clerk"
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.employment_pattern.clerk')))]), _c('option', {
    attrs: {
      "value": "attendant"
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.employment_pattern.attendant')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.createContract
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.button.create_contract')))])]), (_vm.isPartPattern) ? _c('div', {
    staticClass: "margin-top"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.shift_classes')))]), (_vm.shiftClasses.length > 0) ? _c('div', [_vm._l((_vm.shiftClasses), function(shiftClass) {
    return _c('div', {
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contractShiftClassIds),
        expression: "contractShiftClassIds"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": shiftClass.id,
        "checked": Array.isArray(_vm.contractShiftClassIds) ? _vm._i(_vm.contractShiftClassIds, shiftClass.id) > -1 : (_vm.contractShiftClassIds)
      },
      on: {
        "click": function($event) {
          var $$a = _vm.contractShiftClassIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = shiftClass.id,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.contractShiftClassIds = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.contractShiftClassIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.contractShiftClassIds = $$c
          }
        }
      }
    }), _vm._v(_vm._s(shiftClass.view_name) + "　" + _vm._s(shiftClass.time_from) + "〜" + _vm._s(shiftClass.time_to)), (shiftClass.break_time !== null) ? _c('span', [_vm._v("（休憩 " + _vm._s(shiftClass.break_time) + "分）")]) : _vm._e()])])
  }), _c('a', {
    staticClass: "btn btn-sm btn-default",
    on: {
      "click": _vm.saveContractShiftClasses
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.button.save_shift_classes')))]), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.shift_classes_recreate')))])], 2) : _c('p', {
    staticClass: "help-block text-warning"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.no_shift_classes')))])]) : _vm._e()])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('onboarding.label.documents')))]), (_vm.documents.length === 0) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.no_documents')))]) : _vm._e(), _vm._l((_vm.documents), function(document) {
    return _c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_vm._v(_vm._s(document.document_type_i18n) + " "), (_vm.latestSubmission(document)) ? [_c('span', {
      staticClass: "label",
      class: _vm.statusClass(_vm.latestSubmission(document).status)
    }, [_vm._v(_vm._s(_vm.latestSubmission(document).status_i18n))]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.latestSubmission(document).submission_no) + _vm._s(_vm.$t('onboarding.label.submission_no_suffix')))]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.latestSubmission(document).created_at_format))]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("（" + _vm._s(_vm.latestSubmission(document).files.length) + _vm._s(_vm.$t('onboarding.label.file_unit')) + "）")])] : _vm._e(), (document.not_applicable) ? _c('span', {
      staticClass: "label label-default"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.label.not_applicable')))]) : _vm._e(), (_vm.isNotSubmitted(document)) ? _c('span', {
      staticClass: "label label-default"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.label.not_submitted')))]) : _vm._e()], 2), (!_vm.latestSubmission(document) && document.not_applicable) ? _c('div', {
      staticClass: "panel-body"
    }, [_c('p', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.label.not_applicable')))])]) : _vm._e(), (_vm.isNotSubmitted(document)) ? _c('div', {
      staticClass: "panel-body"
    }, [_c('p', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.label.not_submitted')))])]) : _vm._e(), (_vm.latestSubmission(document)) ? _c('div', {
      staticClass: "panel-body"
    }, [(document.is_my_number && !_vm.isHrManager) ? _c('div', {
      staticClass: "alert alert-info"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.message.my_number_hidden')))]) : _c('div', {
      staticClass: "row"
    }, _vm._l((_vm.latestSubmission(document).files), function(file) {
      return _c('div', {
        staticClass: "col-sm-6 margin-top"
      }, [(!file.is_my_number || _vm.isHrManager) ? _c('div', {
        staticClass: "document-file"
      }, [(file.is_image) ? _c('img', {
        attrs: {
          "src": _vm.fileUrl(file)
        }
      }) : _c('iframe', {
        attrs: {
          "src": _vm.fileUrl(file),
          "type": "application/pdf"
        }
      })], 1) : _vm._e(), _c('p', [_c('a', {
        attrs: {
          "href": _vm.fileUrl(file),
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(file.file_name))])])])
    })), (_vm.latestSubmission(document).expiry_date_format) ? _c('p', {
      staticClass: "margin-top"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.label.expiry_date')) + "：" + _vm._s(_vm.latestSubmission(document).expiry_date_format))]) : _vm._e(), (_vm.latestSubmission(document).status === 'rejected') ? _c('p', {
      staticClass: "text-danger margin-top"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.label.review_comment')) + "：" + _vm._s(_vm.latestSubmission(document).review_comment))]) : _vm._e(), (_vm.latestSubmission(document).status === 'submitted') ? _c('div', [_c('hr'), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.label.review_comment')))]), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.reviewComments[document.document_type]),
        expression: "reviewComments[document.document_type]"
      }],
      staticClass: "form-control",
      attrs: {
        "rows": "2"
      },
      domProps: {
        "value": _vm._s(_vm.reviewComments[document.document_type])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.reviewComments,
            $$idx = document.document_type;
          if (!Array.isArray($$exp)) {
            _vm.reviewComments[document.document_type] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    })]), _c('div', {
      staticClass: "margin-top"
    }, [_c('a', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.approve(document.document_type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.button.approve_submission')))])]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          _vm.reject(document.document_type)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-undo"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.button.reject_submission')))])])])]) : _vm._e(), (_vm.pastSubmissions(document).length > 0) ? _c('div', {
      staticClass: "margin-top"
    }, [_c('hr'), _c('a', {
      on: {
        "click": function($event) {
          _vm.toggleHistory(document.document_type)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.isHistoryOpened(document.document_type) ? 'fa-caret-down' : 'fa-caret-right'
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.label.past_submissions')) + "（" + _vm._s(_vm.pastSubmissions(document).length) + _vm._s(_vm.$t('onboarding.label.submission_unit')) + "）")])]), (_vm.isHistoryOpened(document.document_type)) ? _c('div', _vm._l((_vm.pastSubmissions(document)), function(submission) {
      return _c('div', {
        staticClass: "past-submission margin-top"
      }, [_c('span', {
        staticClass: "label",
        class: _vm.statusClass(submission.status)
      }, [_vm._v(_vm._s(submission.status_i18n))]), _vm._v(" "), _c('span', {
        staticClass: "text-muted"
      }, [_vm._v(_vm._s(submission.submission_no) + _vm._s(_vm.$t('onboarding.label.submission_no_suffix')))]), _vm._v(" "), _c('span', {
        staticClass: "text-muted"
      }, [_vm._v(_vm._s(submission.created_at_format))]), (submission.expiry_date_format) ? _c('span', {
        staticClass: "text-muted"
      }, [_vm._v("　" + _vm._s(_vm.$t('onboarding.label.expiry_date')) + "：" + _vm._s(submission.expiry_date_format))]) : _vm._e(), (submission.status === 'rejected') ? _c('p', {
        staticClass: "text-danger"
      }, [_vm._v(_vm._s(_vm.$t('onboarding.label.review_comment')) + "：" + _vm._s(submission.review_comment))]) : _vm._e(), (document.is_my_number && !_vm.isHrManager) ? _c('div', {
        staticClass: "alert alert-info"
      }, [_vm._v(_vm._s(_vm.$t('onboarding.message.my_number_hidden')))]) : _c('div', {
        staticClass: "row"
      }, _vm._l((submission.files), function(file) {
        return _c('div', {
          staticClass: "col-sm-6"
        }, [_c('p', [_c('a', {
          attrs: {
            "href": _vm.fileUrl(file),
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(file.file_name))])])])
      }))])
    })) : _vm._e()]) : _vm._e()]) : _vm._e()])
  })], 2)]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('onboarding.label.profile')))]), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.profile_help')))]), _c('table', {
    staticClass: "table table-bordered profile-table"
  }, [_c('tbody', [_vm._l((_vm.profileFields), function(field) {
    return _c('tr', [_c('th', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.' + field.key)))]), _c('td', [(!_vm.profileEditing || field.type === 'readonly') ? _c('span', [_vm._v(_vm._s(_vm.profileValue(field)))]) : [(field.type === 'text') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profileForm[field.key]),
        expression: "profileForm[field.key]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(_vm.profileForm[field.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.profileForm,
            $$idx = field.key;
          if (!Array.isArray($$exp)) {
            _vm.profileForm[field.key] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    }) : _vm._e(), (field.type === 'tel') ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profileForm[field.key]),
        expression: "profileForm[field.key]"
      }],
      staticClass: "form-control",
      class: {
        required: !_vm.isTelValid(field.key)
      },
      attrs: {
        "type": "tel",
        "placeholder": "例)090-1234-5678",
        "maxlength": "13"
      },
      domProps: {
        "value": _vm._s(_vm.profileForm[field.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.profileForm,
            $$idx = field.key;
          if (!Array.isArray($$exp)) {
            _vm.profileForm[field.key] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isTelValid(field.key)),
        expression: "!isTelValid(field.key)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.fomat_tel')))])] : _vm._e(), (field.type === 'date') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profileForm[field.key]),
        expression: "profileForm[field.key]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": _vm._s(_vm.profileForm[field.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.profileForm,
            $$idx = field.key;
          if (!Array.isArray($$exp)) {
            _vm.profileForm[field.key] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    }) : _vm._e(), (field.type === 'sex') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profileForm[field.key]),
        expression: "profileForm[field.key]"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$exp = _vm.profileForm,
            $$idx = field.key;
          if (!Array.isArray($$exp)) {
            _vm.profileForm[field.key] = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            })[0]
          } else {
            $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            })[0])
          }
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.sex_male')))]), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.sex_female')))])]) : _vm._e(), (field.type === 'account_type') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profileForm[field.key]),
        expression: "profileForm[field.key]"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$exp = _vm.profileForm,
            $$idx = field.key;
          if (!Array.isArray($$exp)) {
            _vm.profileForm[field.key] = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            })[0]
          } else {
            $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            })[0])
          }
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.account_ordinary')))]), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.account_current')))])]) : _vm._e(), (field.type === 'commute') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profileForm[field.key]),
        expression: "profileForm[field.key]"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$exp = _vm.profileForm,
            $$idx = field.key;
          if (!Array.isArray($$exp)) {
            _vm.profileForm[field.key] = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            })[0]
          } else {
            $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            })[0])
          }
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _c('option', {
      attrs: {
        "value": "car"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.commute_car')))]), _c('option', {
      attrs: {
        "value": "motorbike"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.commute_motorbike')))]), _c('option', {
      attrs: {
        "value": "bicycle"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.commute_bicycle')))]), _c('option', {
      attrs: {
        "value": "walk"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.commute_walk')))]), _c('option', {
      attrs: {
        "value": "public_transport"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.commute_public_transport')))])]) : _vm._e(), (field.type === 'yes_no') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profileForm[field.key]),
        expression: "profileForm[field.key]"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$exp = _vm.profileForm,
            $$idx = field.key;
          if (!Array.isArray($$exp)) {
            _vm.profileForm[field.key] = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            })[0]
          } else {
            $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            })[0])
          }
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.yes')))]), _c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.no')))])]) : _vm._e(), (field.type === 'flag') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profileForm[field.key]),
        expression: "profileForm[field.key]"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$exp = _vm.profileForm,
            $$idx = field.key;
          if (!Array.isArray($$exp)) {
            _vm.profileForm[field.key] = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            })[0]
          } else {
            $$exp.splice($$idx, 1, Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            })[0])
          }
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.no')))]), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(_vm.$t('onboarding.profile.yes')))])]) : _vm._e(), (field.type === 'number') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profileForm[field.key]),
        expression: "profileForm[field.key]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": _vm._s(_vm.profileForm[field.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.profileForm,
            $$idx = field.key;
          if (!Array.isArray($$exp)) {
            _vm.profileForm[field.key] = _vm._n($event.target.value)
          } else {
            $$exp.splice($$idx, 1, _vm._n($event.target.value))
          }
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }) : _vm._e(), (field.type === 'month') ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profileForm[field.key]),
        expression: "profileForm[field.key]"
      }],
      staticClass: "form-control",
      class: {
        required: !_vm.isMonthValid(field.key)
      },
      attrs: {
        "type": "text",
        "placeholder": "YYYY-MM",
        "maxlength": "7"
      },
      domProps: {
        "value": _vm._s(_vm.profileForm[field.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.profileForm,
            $$idx = field.key;
          if (!Array.isArray($$exp)) {
            _vm.profileForm[field.key] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isMonthValid(field.key)),
        expression: "!isMonthValid(field.key)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.message.month_format')))])] : _vm._e()]], 2)])
  }), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('onboarding.profile.bank_account_number')))]), _c('td', [(_vm.user.bank_account_registered) ? _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.label.submitted')))]) : _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.not_submitted')))])])]), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('onboarding.label.my_number')))]), _c('td', [(_vm.user.my_number_submitted) ? _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.label.submitted')))]) : _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.not_submitted')))])])])], 2)]), (!_vm.profileEditing) ? _c('div', [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.startProfileEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.button.edit_profile')))])])]) : _c('div', [_c('a', {
    staticClass: "btn btn-primary",
    class: _vm.profileSaving ? 'disabled' : '',
    on: {
      "click": _vm.saveProfile
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.button.save_profile')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.cancelProfileEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.button.cancel')))])])])]), (!_vm.isCompleted && _vm.registerChecks) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('onboarding.label.registration')))]), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.registration_help')))]), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.optional_documents_help')))]), _c('table', {
    staticClass: "table table-bordered table-condensed register-check-table"
  }, [_c('tbody', _vm._l((_vm.registerChecks.items), function(item) {
    return _c('tr', [_c('th', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(item.label))]), _c('td', [(item.ok) ? _c('span', {
      staticClass: "text-success"
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.label.check_ok')))]), (_vm.isOptionalItem(item)) ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("（" + _vm._s(_vm.$t('onboarding.label.optional_note')) + "）")]) : _vm._e()]) : (_vm.isOptionalItem(item)) ? [_c('span', {
      staticClass: "label label-default"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.label.optional')))]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(item.message))])] : _c('span', {
      staticClass: "text-danger"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.message))])])], 2)])
  }))]), (!_vm.registerReady && !_vm.canForceRegister) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.registration_not_ready')))]) : _vm._e(), (!_vm.registerReady && _vm.canForceRegister) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.message.force_registration_help')))]) : _vm._e(), _c('a', {
    staticClass: "btn btn-lg",
    class: [_vm.registerReady ? 'btn-success' : 'btn-warning', (!_vm.canPressRegister || _vm.registering) ? 'disabled' : ''],
    on: {
      "click": _vm.register
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.registerReady ? _vm.$t('onboarding.button.complete_registration') : _vm.$t('onboarding.button.force_complete_registration')))])])])]) : _vm._e(), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/onboarding"
    }
  }, [_vm._v(_vm._s(_vm.$t('onboarding.button.back')))])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-92f357bc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/onboarding-detail.pug
// module id = 897
// module chunks = 1